import api from 'Application/api/api';

const createUser = (signal, values) =>
	api.post(
		'/users',

		values,
		{
			signal,
		},
	);

export default createUser;
